import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import type { SelectSection } from '../../../../types/FormBuilder.types'

const formBuilderQueue = useBuilder('formBuilder')

const SelectCommands = {
  updateBlock: formBuilderQueue.createBlockCommand<SelectSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { SelectCommands }
